export const PinActive = ({ color = "#27272A" }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.34207 10.2681L6.09528 13.0213L2.68306 16.4336C2.43898 16.6776 2.43898 17.0734 2.68306 17.3174C2.92714 17.5615 3.32286 17.5615 3.56694 17.3174L6.97917 13.9052L9.73238 16.6584C11.0597 17.9857 13.3324 17.2417 13.6179 15.3864L14.2341 11.381C14.2864 11.0412 14.5029 10.749 14.8129 10.6003L17.1083 9.49846C18.5325 8.81485 18.8541 6.92909 17.7371 5.81202L14.1885 2.26344C13.0714 1.14637 11.1857 1.46801 10.502 2.89222L9.40024 5.18763C9.25147 5.49758 8.95935 5.71415 8.61955 5.76643L4.61406 6.38265C2.75878 6.66808 2.01476 8.94081 3.34207 10.2681Z"
      fill={color}
    />
  </svg>
)

export default PinActive
